module.exports = __webpack_public_path__ + "img/law_activity_5_button.96f4baf0.jpg";